import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useDispatch, useSelector } from "react-redux";
import { ShowAppBar } from "../../Redux/Action";
import { setJsonData } from "../../Redux/Action";
import { useEffect } from "react";
import { fetchIndicatorData } from "../Services/api";
import { GetColor } from "./constant";
import { CircularProgress, Skeleton, Stack } from "@mui/material";
const TechIndicator = (props) => {
  const [showdetails, setShowDetails] = useState(false);
  const [selectedTick, setselectedTick] = useState(null);
  const [filterData, setfilterData] = useState(null);
  const jsonData = useSelector((state) => state.jsonData);
  const selectIndicator = useSelector((state) => state.SelectedDropdownOption);
  const selectedExchange = useSelector((state) => state.SetExchange);
  const selecttimeFrame = useSelector((state) => state.ActiveButton);
  const serachValue = useSelector((state) => state.searchvalue);
  const isLoading = useSelector((state) => state.isLoading);

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectIndicator === "Indicator") {
      fetchIndicatorData(
        selecttimeFrame,
        selectedExchange,
        dispatch,
        setJsonData,
        isLoading
      );
    }
  }, [selecttimeFrame, selectedExchange, selectIndicator, dispatch]);

  const handleShowDetails = (details) => {
    setselectedTick(details);
    setShowDetails(true);
    dispatch(ShowAppBar(true));
  };

  const handleShowDetails1 = () => {
    setselectedTick(null);
    setShowDetails(false);
    dispatch(ShowAppBar(false));
  };
  // Function to filter array data
  const filterArrayData = (dataArray) => {
    return dataArray.filter((item) =>
      item.Ticker.trim()
        .toLowerCase()
        .includes(serachValue.trim().toLowerCase())
    );
  };
  const filterObjectData = (dataObject) => {
    if (dataObject && dataObject.Data) {
      return dataObject.Data.filter(
        (item) =>
          serachValue &&
          item.Ticker &&
          item.Ticker.trim()
            .toLowerCase()
            .includes(serachValue.trim().toLowerCase())
      );
    }
    return [];
  };
  const getFilteredData = () => {
    debugger;
    if (!jsonData) {
      return [];
    }

    if (Array.isArray(jsonData)) {
      return filterArrayData(jsonData);
    } else if (typeof jsonData === "object") {
      return filterObjectData(jsonData);
    }

    return [];
  };

  useEffect(() => {
    if (serachValue === "") {
      setfilterData(jsonData.Data);
    } else {
      setfilterData(getFilteredData());
    }
  }, [jsonData, serachValue]);

  return (
    isLoading ? 
    <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'50vh'}}>
<CircularProgress />

    </div>
    :
    <div>
      {!showdetails ? (
        <Card style={{ height: "100vh" }}>
          <CardContent
            style={{
              alignItems: "center",
              height: "80vh",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "80",
                  fontWeight: "bold",
                  padding: "0px 0px 10px 0px",
                  position: "sticky",
                  top: "0",
                  color: "grey",
                  backgroundColor: "white",
                  zIndex: "1",
                }}
              >
                <div style={{ flex: "1" }}>Symbol</div>
                <div style={{ flex: "1" }}>Summary %</div>
              </div>
              <div style={{ flex: "1", overflowY: "auto" }}>
                {/* {Object.keys(jsonData).length !== 0 && */}
                {filterData &&
                  filterData.length !== 0 &&
                  filterData.map((values, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "80",
                        borderBottom: "1px solid grey",
                        padding: "20px 0px 20px 0px",
                      }}
                    >
                      <div style={{ flex: "1" }}>
                        {values.Ticker.toUpperCase()}
                      </div>
                      {/* <div style={{ flex: "1" }}>
                  {values.IndicatorSummary.Summary}
                </div> */}
                      <div
                        style={{
                          flex: "1",
                        }}
                      >
                        <div
                          style={{
                            color: GetColor(values.IndicatorSummary.Summary),
                          }}
                        >
                          {values.IndicatorSummary.SummaryPercent}
                        </div>
                        <div>
                          {values.IndicatorSummary.Summary.toUpperCase()}
                        </div>
                      </div>
                      <div onClick={() => handleShowDetails(values)}>
                        <ChevronRightIcon />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </CardContent>
        </Card>
      ) : null}

      {showdetails ? (
        <Card
          style={{
            border: "1px solid green",
            height: "99vh",
            overflowY: "auto",
          }}
        >
          <div>
            <div>
              <Button
                style={{
                  display: "flex",
                  fontWeight: "bold",
                  fontSize: "medium",
                }}
                onClick={() => handleShowDetails1()}
              >
                Close
              </Button>
            </div>
          </div>
          <CardContent>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <h3
                style={{
                  color: GetColor(selectedTick.IndicatorSummary.Summary),
                }}
              >
                {selectedTick.Ticker.toUpperCase()}
              </h3>
            </div>
            <div
              style={{
                fontSize: "16px",
                fontFamily: "sans-serif",
              }}
            >
              {selectedTick.IndicatorResults.map((values, index) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    margin: "10px",
                  }}
                >
                  <div style={{ textAlign: "left" }}>
                    <div> {values.Indicator.toUpperCase()}</div>
                    <div style={{ color: GetColor(values.Indication) }}>
                      {values.Indication.toUpperCase()}
                    </div>
                  </div>
                  <div style={{ color: GetColor(values.Indication) }}>
                    {values.Value}
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      ) : null}
    </div>
  );
};

export default TechIndicator;
